import React, { useEffect, useState } from "react";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
    DialogSystemGLPure,
    GridPure,
    HeaderHLPure,
    SimpleLoading,
} from "../../pures";
import "./clients-dashboard.css";
import { useTranslation } from "react-i18next";
import { AgeAndGenderGraph, BranchOfficeMap, DashboardDateFilter, SalesGraph, StatCard, TopPreferencesGraph } from "../../pures/dashboard";
import moment from "moment";
import RatingsReviews from "../../pures/dashboard/ratings-reviews";
import { Rating } from "@progress/kendo-react-inputs";

const ClientsDashboardView = (props) => {
    const {
        isLoading,
        errorMessage,
        toggleError,
        dates,
        handleDateChange,
        dashboardData,
        clientsData,
        handleSearch,
        handleViewUserDetails,
        setData,
        isDataDashboard,
        reviews
    } = props;

    const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'allClientsScreen' });
    const { t: tCommon } = useTranslation('common');

    const hideActions = useMediaQuery('(max-width: 820px)');
    const [userPreferences, setUserPreferences] = useState([])
    const [days, setDays] = useState([])
    const [longDays, setLongDays] = useState([])

    useEffect(() => {
        if (dashboardData) {
            const auxUserPreferences = dashboardData.userPreferences.map((userPreference) => {
                return { name: tCommon(userPreference.name), quantity: userPreference.quantity }
            })

            setUserPreferences(auxUserPreferences)
        }
    }, [i18n.language, dashboardData])


    useEffect(() => {
        moment.locale(i18n.language === 'en' ? 'en' : 'es')
        setDays(moment.weekdaysShort())
        setLongDays(moment.weekdays())
    }, [i18n.language])

    return (
        <>
            <DialogSystemGLPure
                toggleErrorRequesting={toggleError}
                showErrorRequesting={!!errorMessage}
                messageError={errorMessage}
            />
            {isLoading
                ? <div className='loading'>
                    <SimpleLoading />
                </div>
                : dashboardData
                    ? (<div className={"clientsDashboardView dashboardView"}>
                        <Container>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <HeaderHLPure title={t("title")} />
                                </Grid>

                                <Grid item xs={12} className="clientsDashboardView-dashboard">
                                    <div className="clientsDashboardView-dashboard-subgrid1">
                                        {/* DATE FILTER */}
                                        <DashboardDateFilter dates={dates} handleChangeDate={handleDateChange} handleSearch={handleSearch} />

                                        {/* RECURRENCY RATE */}
                                        <div className="dashboardView-card cdb-recurrency">
                                            <p className="dashboardView-card-title">{t("purchaseFrequency")}</p>
                                            <p className="dashboardView-card-value">{dashboardData.recurrency.value ? dashboardData.recurrency.value.toFixed(1) : "N/D"}</p>
                                        </div>

                                        {/* AVERAGE TOTAL */}
                                        <StatCard className="cdb-total"
                                            title={t("averageAmount")}
                                            value={dashboardData.average.value ? `$${dashboardData.average.value.toFixed(2)}` : "N/D"}
                                        />

                                        {/* COMMENT ANALYSIS */}
                                        <div className="dashboardView-card cdb-commentAnalysis">
                                            <p className="dashboardView-card-title cdb-commentAnalysis-title">{t("commentAnalysis")}</p>
                                            <div className="dashboardView-card-rankingContainer">
                                                <p className="dashboardView-card-value">{reviews.rankingDescription ? t(reviews.rankingDescription) : t("noCommentAnalysis")}</p>
                                            </div>
                                            <div className="dashboardView-card-starsContainer">
                                                {reviews.rankingDescription ? <Rating value={Math.floor(reviews.rankingResult)} readonly /> : ''}
                                            </div>
                                        </div>

                                        {/* MAP */}
                                        <div className="dashboardView-card cdb-map dashboard-graph-card">
                                            <p className="dashboardView-card-title">{t("saleLocations")}</p>
                                            <BranchOfficeMap data={dashboardData.branchOfficeSales} />
                                        </div>
                                    </div>

                                    {/* SALES GRAPH */}
                                    <SalesGraph dataAmount={dashboardData.amountAverageByWeek} dataSales={dashboardData.totalTicketsAverageByWeek} days={days} longDays={longDays} />

                                    <div className="clientsDashboardView-dashboard-subgrid2">
                                        {/* AGE AND GENDER GRAPH */}
                                        <AgeAndGenderGraph title={t("ageAndGender")} data={dashboardData.genderAndAge} />

                                        {/* TOP PREFERENCES GRAPH */}
                                        <TopPreferencesGraph data={userPreferences} />
                                    </div>
                                </Grid>

                                <Grid item xs={12} style={{ marginTop: 24 }}>
                                    <HeaderHLPure headingNumber={2} title={t("clientList")} />
                                </Grid>

                                <Grid item xs={12}>
                                    <GridPure
                                        setData={setData}
                                        isDataDashboard={isDataDashboard}
                                        className="clientsDashboard-grid"
                                        dataGrid={clientsData}
                                        skip={0}
                                        take={6}
                                        rowsItems={[{
                                            field: 'firstName',
                                            title: tCommon("name"),
                                            width: 150,
                                            sorteable: true
                                        },
                                        {
                                            field: 'firstLastName',
                                            title: tCommon("surname"),
                                            width: 150,
                                            sorteable: true
                                        },
                                        {
                                            field: 'secondLastName',
                                            title: '',
                                            width: 150,
                                            sorteable: true
                                        },
                                        {
                                            field: 'email',
                                            title: tCommon("mail"),
                                            width: 250,
                                            sorteable: true
                                        },
                                        {
                                            field: 'Acciones',
                                            title: hideActions ? '' : tCommon("actions"),
                                            actions: true,
                                            width: hideActions ? 80 : 200,
                                            headerClassName: 'actionHeader'
                                        }]}
                                        actions={[
                                            {
                                                type: 'label',
                                                value: tCommon('export'),
                                                onClick: (dataItem) => { console.log('Details...', dataItem) }
                                            },
                                            {
                                                type: 'view-details',
                                                value: tCommon('details'),
                                                onClick: handleViewUserDetails
                                            }
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <HeaderHLPure title={t("ratingsReviews")} />
                                </Grid>

                                <Grid item xs={12} className="clientsDashboardView-ratingsReviews">
                                    <RatingsReviews reviews={reviews} data={clientsData} />

                                </Grid>
                            </Grid>
                        </Container>
                    </div >)
                    : null
            }
        </>
    )
}

export { ClientsDashboardView as default };